export default {
  vision_save__:
    "Vision СОХРАНЯЕТ ВАМ неделИ и месяцы, избавляя от мучительного копания на форумах, чатах и каналах.".toUpperCase(),
  say_goodbuy__:
    "Забудьте про устаревшие форумы с дизайном из 2012 года и платформы, которыми управляют люди, далекие от темы.".toUpperCase(),
  top_projects: "TOP проекты".toUpperCase(),
  lorem_ipsum__: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
};
